import { SceneConfig, BgmConfig } from "../lib/types";

/**
 * 模型展示视频：恐怖故事大比拼
 *
 * 结构：
 *   1. 开场 — 展示提示词 "用 50 个字写一个发生在汽车里的恐怖故事"
 *   2-8. 逐一展示 7 个 AI 模型的截图回答（带恐怖滤镜 + BGM）
 *   9. 结尾 — "你觉得哪个写得最好？"
 */

export const modelShowcaseConfig: SceneConfig[] = [
  // ── S00: 开场 ──
  {
    sceneId: "S00",
    durationInFrames: 120, // ~4s @ 30fps
    layers: [
      {
        component: "SmashText",
        preset: "drop",
        props: {
          mainText: "用 50 个字",
          subText: "写一个发生在汽车里的恐怖故事",
          highlight: ["50 个字", "恐怖故事"],
          style: { theme: "#FF0000", highlightColor: "#FF0000" },
        },
      },
      {
        component: "VisualEffect",
        preset: "vhsHorror",
      },
    ],
  },

  // ── S01: DeepSeek V4 Pro ──
  {
    sceneId: "S01",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/deepseek-v4-pro.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "nightmare",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "DeepSeek V4 Pro",
        },
      },
    ],
  },

  // ── S02: 豆包专家模式 ──
  {
    sceneId: "S02",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/doubao-expert.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "flicker",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "豆包专家模式",
        },
      },
    ],
  },

  // ── S03: Gemini 3.6 Thinking ──
  {
    sceneId: "S03",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/gemini-3-6-thinking.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "nightmare",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "Gemini 3.6 Thinking",
        },
      },
    ],
  },

  // ── S04: GLM 5.1 ──
  {
    sceneId: "S04",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/glm-5-1.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "vhsHorror",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "GLM 5.1",
        },
      },
    ],
  },

  // ── S05: GPT 5.6 SOL ──
  {
    sceneId: "S05",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/gpt-5-6-sol.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "nightmare",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "GPT 5.6 SOL",
        },
      },
    ],
  },

  // ── S06: Kimi K 2.6 ──
  {
    sceneId: "S06",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/kimi-k-2-6.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "flicker",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "Kimi K 2.6",
        },
      },
    ],
  },

  // ── S07: MiniMax M3 ──
  {
    sceneId: "S07",
    durationInFrames: 120,
    layers: [
      {
        component: "ModelCard",
        preset: "zoomIn",
        props: {
          imageSrc: "images/minimax-m3.png",
        },
      },
      {
        component: "VisualEffect",
        preset: "vhsHorror",
      },
      {
        component: "Badge",
        preset: "redBadge",
        props: {
          text: "MiniMax M3",
        },
      },
    ],
  },

  // ── S08: 结尾 — 互动提问 ──
  {
    sceneId: "S08",
    durationInFrames: 150, // ~5s
    layers: [
      {
        component: "SmashText",
        preset: "drop",
        props: {
          mainText: "你觉得哪个模型写得好？",
          subText: "评论区告诉我",
          highlight: ["哪个模型"],
          style: { theme: "#FF0000", highlightColor: "#FF0000" },
        },
      },
      {
        component: "VisualEffect",
        preset: "vhsHorror",
      },
    ],
  },
];

/** BGM 配置：全片循环播放 */
export const modelShowcaseBgm: BgmConfig = {
  src: "bgm/suspense-mysterious.mp3",
  volume: 0.12,
  loop: true,
};
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
